// extracted by mini-css-extract-plugin
module.exports = {"wiki":"styles_wiki__2kt5e"};